module.exports = __webpack_public_path__ + "media/images/countryrect/ni-3fec21e58b632948b5138495c8e13b5a.svg";